const urlEndpoints = {
    profile: '/customers/v2/profile',
    getCart: '/cart/v4/',
    getCartPickup: 'cart/v4/pickup',
    ordersHistory: '/customers/orders/history',
    locationPredictions: 'location/predictions',
    getLocation: 'location/getLoc/v2',
    verifyLocation: 'location/verify',
    pickupStores: '/location/stores?features=pickup&training_mode=false&country=US',
    homePage: 'content/v1/delivery/content/find/home-page?v=5',
    configuration: '/content/configuration',
    categories: 'inventory/digital/v3/store/{storeId}/facet',
    catering: 'inventory/digital/v3/store/{storeId}/preorder/facet',
    updateProfile: '/customers/customers/updateProfile',
    faqs: 'content/faqs?app=7now_landing&version=1',
    getCities: 'content/cities?country=US',
    filters: 'catalog/products/filters',
    getProduct: 'inventory/store/{storeId}/products/{id}/details',
    getShortProfile: '/customers/customers/v2/getShortUserProfileForTCV2',
    createUser: 'auth/mfa/login/otp/verify',
    test: ' jwt/token',
    deliveryPlaceOrder: '/cart/v4/orders',
    pickupPlaceOrder: '/cart/v4/orders/pickup',
}

const lambdaUrlMapping = new Map()
lambdaUrlMapping.set(urlEndpoints.profile, 'updateProfileFields')
lambdaUrlMapping.set(urlEndpoints.getCart, 'update-cart-v4')
lambdaUrlMapping.set(urlEndpoints.getCartPickup, 'update-cart-v4-pickup')
lambdaUrlMapping.set(urlEndpoints.ordersHistory, 'getOrderHistoryByCustomer')
lambdaUrlMapping.set(urlEndpoints.locationPredictions, 'googleAutocomplete')
lambdaUrlMapping.set(urlEndpoints.getLocation, 'getLocationV2')
lambdaUrlMapping.set(urlEndpoints.verifyLocation, 'uspsValidation')
lambdaUrlMapping.set(urlEndpoints.pickupStores, 'searchStores')
lambdaUrlMapping.set(urlEndpoints.homePage, 'specials')
lambdaUrlMapping.set(urlEndpoints.configuration, 'getConfiguration')
lambdaUrlMapping.set(urlEndpoints.categories, 'getAvailableProductByFacetSearch')
lambdaUrlMapping.set(urlEndpoints.catering, 'getAvailableCateringProductByFacetSearch')
lambdaUrlMapping.set(urlEndpoints.updateProfile, 'updateUserProfile')
lambdaUrlMapping.set(urlEndpoints.faqs, 'getFaqQuestions')
lambdaUrlMapping.set(urlEndpoints.getCities, 'getCities')
lambdaUrlMapping.set(urlEndpoints.filters, 'getProductFilters')
lambdaUrlMapping.set(urlEndpoints.getProduct, 'getAvlProductByStoreNutritionalDtl')
lambdaUrlMapping.set(urlEndpoints.getShortProfile, 'getShortUserProfileForTCV2')
lambdaUrlMapping.set(urlEndpoints.createUser, 'createUserProfile')
lambdaUrlMapping.set(urlEndpoints.deliveryPlaceOrder, 'placeOrder-v4')
lambdaUrlMapping.set(urlEndpoints.pickupPlaceOrder, 'placeOrder-v4-pickup')
lambdaUrlMapping.set(urlEndpoints.test, 'test')

export default lambdaUrlMapping
